<template>	   
	<div>
    <v-stepper v-model="stepper" vertical>
      <v-stepper-step :complete="stepper > 1" step="1">
        Información de la variable
        <small>Datos basicos de registro de una variable</small>
      </v-stepper-step>

      <v-stepper-content step="1">
        <v-card>
          <v-card-title primary-title>
            <h4 class="headline">Editar Variable</h4>
          </v-card-title>
          <v-card-text>
            <v-layout row justify-center>
              <v-flex xs9 pa-1> 
                <v-text-field 
                  name="name"
                  label="Nombre de la variable" solo
                  id="id" v-model="variable.name"
                ></v-text-field>
                <v-autocomplete :items="types"item-text="label" item-value="value"
                  name="id_type"
                  label="Zona de extracción"
                  id="id" solo v-model="variable.id_type"
                ></v-autocomplete>
                <v-autocomplete
                  :items="typesVariables" @change="changeType()"
                  v-model="variable.type" solo disabled
                  label="Tipo de variable"
                ></v-autocomplete>
                <v-layout row wrap>
                  <v-flex xs4 pa-1>
                    <v-text-field
                      name="no_data_value"
                      v-model="variable.no_data_value"
                      label="Valor de dato errado" :disabled="constantDisabled"
                      id="no_data_value" solo
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs4 pa-1>
                    <v-text-field
                      v-model="variable.default_value"
                      name="default_value" :disabled="constantDisabled"
                      label="Valor por defecto"
                      id="default_value" solo
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs4 pa-1>
                    <v-autocomplete :items="ecuations"
                      item-text="label" item-value="value"
                      name="nodata_proccess"
                      label="Proccesos de datos nulos"
                      id="nodata_proccess" :disabled="constantDisabled"
                      solo  v-model="variable.nodata_proccess"
                    ></v-autocomplete>
                  </v-flex>
                </v-layout>
                <v-textarea
                  v-model="variable.description"
                  label="Descripcion"
                  name="description"
                  textarea solo @keyup.enter="nextStep()"
                ></v-textarea>
              </v-flex> 
            </v-layout>
          </v-card-text>
       </v-card>
        <v-btn color="primary"  @click="nextStep()">Continuar</v-btn>
        <v-btn text>Cancel</v-btn>
      </v-stepper-content>
      <v-stepper-step :complete="stepper > 2" step="2">
      	Metadata
      	<small>Informacion de referencia de las variables</small>
      </v-stepper-step>
      <v-stepper-content step="2">
        <v-card class="mb-5" v-if="variable.type == 'appears'">
          <v-card-title primary-title>
            Informacion Appears
          </v-card-title>
          <v-card-text>
            <v-layout row justify-center>
              <v-flex xs9 pa-1> 
                <v-autocomplete 
                  :items="products" 
                  item-text="label" item-value="value"
                  name="id_product" 
                  @change="getLayer()"
                  label="Producto" 
                  solo 
                  id="id" 
                  v-model="metadata.id_product"
                ></v-autocomplete>
                <v-autocomplete 
                  item-text="label" item-value="value"
                  name="id_layer" :items="layers"
                  label="Capa" 
                  id="id" solo v-model="metadata.id_layer"
                ></v-autocomplete>
              </v-flex> 
            </v-layout>
          </v-card-text>
        </v-card>
        <v-card class="mb-5" v-if="variable.type == 'ftp'">
          <v-card-title primary-title>
            Informacion Datos extraidos por FTP
          </v-card-title>
          <v-card-text>
            <v-layout row justify-center>
              <v-flex xs9 pa-1> 
                <v-text-field 
                  name="service"
                  label="Servicio" solo
                  id="id" v-model="metadata.service"
                ></v-text-field>
                <v-text-field 
                  name="user"
                  label="Usuario"
                  id="id" solo v-model="metadata.user"
                ></v-text-field>
                <v-text-field 
                  name="password"
                  label="Contraseña"
                  id="id" solo v-model="metadata.password"
                ></v-text-field>
                <v-text-field 
                  name="url"
                  label="URL"
                  id="id" solo v-model="metadata.url"
                ></v-text-field>
              </v-flex> 
            </v-layout>
          </v-card-text>
        </v-card>
        <v-card class="mb-5" v-if="variable.type == 'calculate'">
          <v-card-title primary-title>
            Informacion Dato calculado
          </v-card-title>
          <v-card-text>
            <v-layout row justify-center>
              <v-flex xs9 pa-1> 
                <v-select :items="ecuations"
                  item-text="label"
                  name="id_formula" return-object
                  label="Formula" solo
                  id="id" v-model="metadata.id_formula"
                ></v-select>
              </v-flex> 
            </v-layout>
          </v-card-text>
        </v-card>
        <v-card class="mb-5" v-if="variable.type == 'constant'">
          <v-card-title primary-title>
            Información sobre constante
          </v-card-title>
          <v-card-text>
            <v-layout row justify-center>
              <v-flex xs9 pa-1> 
                <v-autocomplete :items="['Valor fijo', 'Imagen Satelital']"
                  item-text="label"
                  name="id_formula" return-object
                  label="Tipo de constante" solo
                  id="id" v-model="metadata.type"
                ></v-autocomplete>
                <v-layout row wrap v-if="metadata.type == 'Valor fijo'">
                  <v-flex xs12 >
                    <v-text-field 
                      name="Valor" type="number"
                      label="Valor" solo
                      id="id" v-model="metadata.value"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs4>
                    <v-switch label="Indexar a punto" v-model="metadata.indexar"></v-switch>
                  </v-flex>
                  <v-flex xs8>
                    <v-autocomplete
                      :items="['Tartagal', 'Pampa del indio', 'Clorinda', 'Puerto Iguazu']" solo
                      v-model="metadata.point_index"
                      label="Puntos"
                    ></v-autocomplete>
                  </v-flex>
                </v-layout>
                <v-layout row wrap>
                  <v-flex  v-if="metadata.type == 'Imagen Satelital'" xs12>
                    <v-autocomplete
                      :items="['NED']"
                      v-model="metadata.path"
                      label="Archivo" solo
                    ></v-autocomplete>
                    <v-autocomplete
                      :items="[1,2,3,4]"
                      v-model="metadata.layer"
                      label="Capa" solo
                    ></v-autocomplete>
                  </v-flex>
                  <v-flex xs12>
                  </v-flex>
                </v-layout>  
              </v-flex> 
            </v-layout>
          </v-card-text>
        </v-card>
        <v-card class="mb-5" v-if="variable.type == 'database'">
          <v-card-title primary-title>
            Informacion Base de datos
          </v-card-title>
          <v-card-text>
            <v-layout row justify-center>
              <v-flex xs9 pa-1> 
                <v-autocomplete :items="databases"
                  item-text="label" @change="getTables()"
                  name="id_formula" item-value="value" item-label="label"
                  label="Base de datos" solo
                  id="id" v-model="metadata.id_database"
                ></v-autocomplete>
                <v-layout row wrap>
                  <v-flex xs8 >
                    <v-autocomplete :items="tables"
                      item-text="label" @change="getColumns()"
                      name="id_formula" item-value="value" item-label="label"
                      label="Tabla" solo
                      id="id" v-model="metadata.id_table"
                    ></v-autocomplete>
                  </v-flex>
                  <v-flex xs3 offset-xs1>
                    <v-switch label="Punto indexado" v-model="metadata.type_point"></v-switch>
                  </v-flex>
                </v-layout>
                <v-layout row wrap>
                  <v-flex xs4 pa-1>
                    <v-autocomplete :items="columns"
                      name="date_column" 
                      label="Columna de fecha" solo
                      id="date_column" v-model="metadata.date_column"
                    ></v-autocomplete>
                  </v-flex>
                  <v-flex xs4 pa-1>
                    <v-autocomplete :items="columns"
                      item-text="label"
                      name="value_column" 
                      label="Columna de valor" solo
                      id="value_column" v-model="metadata.value_column"
                    ></v-autocomplete>
                  </v-flex>
                  <v-flex xs4 pa-1>
                    <v-autocomplete solo v-if="metadata.type_point"
                      :items="localities"
                      item-text="label" 
                      item-value="value"
                      v-model="metadata.id_point"
                      label="Localidades"
                    >
                       <template v-slot:item="data">              
                        <v-list-item-action >
                          <v-icon>fas fa-globe-europe</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                          <v-list-item-title v-html="data.item.label"></v-list-item-title>
                          <v-list-item-sub-title><strong>Provincia:</strong> {{ data.item.province }}</v-list-item-sub-title>
                        </v-list-item-content>
                      </template>
                    </v-autocomplete>
                    <v-autocomplete v-if="!metadata.type_point" :items="columns"
                      item-text="label"
                      name="point_column" 
                      label="Columna de Punto" solo
                      id="point_column" v-model="metadata.point_column"
                    ></v-autocomplete>
                  </v-flex>
                </v-layout>
              </v-flex> 
            </v-layout>
          </v-card-text>
        </v-card>
        <v-card-actions> 
		        <v-btn color="success" @click="prevStep()">Atras</v-btn>
		        <v-spacer></v-spacer>
		        <v-btn color="success" @click="store()">Guardar</v-btn>
          </v-card-actions>
      </v-stepper-content>
    </v-stepper>
    <v-snackbar
        v-model="alert.active" :color="alert.color" auto-height
      >
        {{ alert.status }}
        <br>{{ alert.messague }}
        <v-btn text color="primary" @click.native="alert.active = false">Close</v-btn>
      </v-snackbar>
	</div>
</template>
<script>
/* eslint-disable */
	export default{
		created() {

		},
		mounted(){
      this.getSelects();
      this.getData();
		},
		props: [

		],
		data(){
			return {
        apiBasePath: process.env.VUE_APP_URL + 'api/',
        stepper: 1,
        typesVariables: ['appears', 'ftp', 'calculate', 'constant', 'database'],
        variable: {
          name: '',
          id_type: '',
          type: '',
          no_data_value: '',
          default_value: '',
          nodata_proccess: '',
          description: ''
        },
        ecuations: [],
        metadata: {},
        alert: {
          active: false,
          messague: '',
          color: ''
        },
        types: [],
        products: [],
        layers: [],
        databases: [],
        tables: [],
        columns: [],
        constantDisabled: false,
        localities: [],
      }
		},
		methods: {
			getData(){
				axios.get(this.apiBasePath + 'gis/variables/edit/' + this.$route.params.id).then((res) => {
					this.variable = res.data.variable;
					this.metadata = res.data.metadata;
					this.originalType = this.variable.type;
					if(this.variable.type == 'appears'){
						this.getLayer();
					}else if(this.variable.type == 'database'){
            this.getDatabases();
            this.getLocalities();
            this.getTables();
            this.getColumns();
          }
				})
			},
      getSelects(){
        axios.get(this.apiBasePath + 'gis/type/getSelect').then((res) => {
          this.types = res.data;
        });
        this.getEcuations();
      },
			nextStep(){
				if(this.variable.type == ''){
          this.alert = {
            active: true,
            messague: 'Elija un tipo de variable'
          }
        }else if(this.variable.type == 'constant'){
          this.stepper = 2;
        }else if(this.variable.type == 'appears'){
          this.getProducts();
          this.stepper = 2;
        }else if(this.variable.type == 'calculate'){
          this.stepper = 2;
        }else if(this.variable.type == 'database'){
          this.getDatabases();
          this.getLocalities();
          this.stepper = 2;
        }else{
          this.stepper = 2;
        }
			},
			prevStep(){
				this.stepper = 1;
			},
			store(){
				let formData = {
					variable: this.variable,
					metadata: this.metadata
				}
        axios.put(this.apiBasePath + "gis/variables/update", formData).then((res) => {
          if(res.data != "Exito"){
            this.alert.active = true;
            this.alert.messague = "Los datos suministrados estan incompletos o no son validos";
            this.alert.color = "error";
          }else{
            this.alert.active = true;
            this.alert.messague = "Creado exitosamente";
            this.alert.color = "success";
            this.getData();
          }
          this.$router.push('/admin/variables');
        }).catch((error) => {
          this.alert.active = true;
          this.alert.messague = "Hubó un error interno en el servidor contacte con el desarrollador";
          this.alert.color = "error";
        });
      },
      returnIndex(status){
        this.$router.push('/admin/variables');
      },
      getProducts(){
        axios.get(this.apiBasePath +  'modis/getSelectProduct').then((res) =>{
          this.products = res.data;
        }).catch((error) =>{
          this.alert.active = true;
          this.alert.messague = "El servicio de appears de la nasa se encuentra temporalmente deshabilitado, intente mas tarde"
        });
      },
      getLayer(){        
        axios.get(this.apiBasePath +  'modis/getSelectLayers/' + this.metadata.id_product).then((res) =>{
          this.layers = res.data
        }).catch(error => {
          this.alert.active = true;
          this.alert.messague = "El servicio de appears de la nasa se encuentra temporalmente deshabilitado, intente mas tarde"
        });
      },
      getEcuations(){
        axios.get(this.apiBasePath + 'gis/formula/getSelect').then((res) => {
          this.ecuations = res.data;
        });
      },
      changeType(){
        if(this.variable.type == 'constant'){
          this.constantDisabled = true;
          this.variable.no_data_value = 0;
          this.variable.default_value = 0;
          this.variable.nodata_proccess = 11;
        }else{
          this.constantDisabled = false;
          this.variable.no_data_value = '';
          this.variable.default_value = '';
          this.variable.nodata_proccess = '';
        }
      },
      getDatabases(){
        axios.get(this.apiBasePath + 'plugins/database/getSelect').then((res) => {
          this.databases = res.data;
        }).catch((error) => {
          this.alert.active = true;
          this.alert.messague = "Hubó un problema interno en el servidor";
        });
      },
      getTables(){
        axios.get(this.apiBasePath + 'plugins/table/getSelect?id_database=' + this.metadata.id_database).then((res) => {
          this.tables = res.data;
        }).catch((error) => {
          this.alert.active = true;
          this.alert.messague = "Hubó un problema interno en el servidor";
        })
      },
      getColumns(){
        axios.get(this.apiBasePath + 'plugins/columns/getSelect?id_table=' + this.metadata.id_table).then((res) => {
          this.columns = res.data;
        }).catch((error) => {
          this.alert.active = true;
          this.alert.messague = "Hubó un problema interno en el servidor";
        })
      },
      getLocalities(){
        axios.get(this.apiBasePath + 'gis/district/getSelect/habilited').then((res) => {
          this.localities = res.data;
        }).catch((error) => {

        });
      },
		},
		watch: {

		},
		computed: {

		},
	}
/* eslint-enable */
</script>
